import Vue from 'vue'

const actions = {
  loadTimeZones ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get('/time_zones.json').then((response) => {
        commit('SET_TIME_ZONES', { time_zones: response.data })

        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}

export default actions
